<template>
  <div class="content">
    <AppNavbar :placeholder="true" :zIndex="999" title="生成问卷"> </AppNavbar>
    <div class="scroll">
      <div class="list">
        <div
          class="item"
          v-for="(item, index) in list"
          :key="index"
          @click="bindItem(item)"
        >
          <div class="id">{{ item.id }}</div>
          <div class="text">科学定制方案</div>
          <div class="status">{{ status[item.cna_state] }}</div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <input
        class="input"
        placeholder="请输入电话号码"
        v-model="phone"
        type="number"
      />
      <div class="btn" @click="bindClick">新增问卷</div>
    </div>
  </div>
</template>
<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
export default {
  components: {
    AppNavbar
  },
  data() {
    return {
      phone: '',
      list: [],
      status: {
        0: '已失效',
        1: '已添加',
        2: '已重置',
        3: '已领取'
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.$http.postBaseApp('que/CnaV2/getCnaNewList', {}).then((res) => {
        res = res.data
        if (res.code == 200) {
          this.list = res.data
        } else {
          this.$toast(res.msg)
        }
      })
    },
    bindItem(item) {
      if (item.cna_state == 1) {
        this.$router.push({
          path: '/cna-question-v2/question',
          query: {
            queId: 9,
            id: item.id
          }
        })
      } else if (item.cna_state == 3) {
        this.$router.push({
          path: '/cna-question-v2/result',
          query: {
            id: item.id
          }
        })
      }
    },
    bindClick() {
      if (!this.phone) {
        this.$toast('电话号码不能为空')
        return
      }
      this.$http
        .postBaseApp('que/CnaV2/createCnaNew', {
          phone: this.phone,
          plan_type: 7
        })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.phone = ''
            this.list.push({
              id: res.data,
              cna_state: 1
            })
          } else {
            this.$toast(res.msg)
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  height: 100vh;
  display: flex;
  align-items: stretch;
  flex-direction: column;

  .scroll {
    flex: 1;
    flex-shrink: 0;
    overflow: scroll;

    .list {
      padding: 16px;

      .item {
        padding: 10px 0;
        height: 40px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f1f1f1;

        .id {
          width: 50px;
        }

        .text {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #000000;
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          margin: 0 10px;
        }

        .status {
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }
  }

  .bottom {
    display: flex;
    display: flex;
    align-items: stretch;
    flex-direction: column;
    padding-bottom: 40px;
  }
}

.input {
  height: 40px;
  line-height: 40px;
  display: block;
  width: 255px;
  margin: 0 auto;
  margin-top: 10px;
}

.btn {
  margin: 0 auto;
  margin-top: 20px;
  text-align: center;
  width: 255px;
  height: 44px;
  line-height: 44px;
  background: #9890fd;
  border-radius: 12px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
}
</style>
